import { render, staticRenderFns } from "./order-upsell-settings.vue?vue&type=template&id=742ae0b5&scoped=true"
import script from "./order-upsell-settings.vue?vue&type=script&lang=js"
export * from "./order-upsell-settings.vue?vue&type=script&lang=js"
import style0 from "./order-upsell-settings.vue?vue&type=style&index=0&id=742ae0b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742ae0b5",
  null
  
)

export default component.exports